export const state = () => ({
  url: '/api/cm/objects',
  manualObject: {}
})

export const mutations = {
  // 주소 객체 저장
  saveAddressObjData (state, data) {
    state.manualObject = data
  }
}
/*
* Created By Jaeuk Ryu <devp011>
*/
export const actions = {
  // 객체 에서 직접 입력 기능
  async saveHostAndNetworkVpn ({commit, state, rootState, dispatch}, {ip, version, menu, zone}) {
    let nameType = void 0
    const ipList = ip.split('/')

    if (zone === 1) {
      nameType = (_.size(ipList) === 2) ? 'IN' : 'IH'
    } else if (zone === 2) {
      nameType = (_.size(ipList) === 2) ? 'EN' : 'EH'
    } else {
      nameType = (_.size(ipList) === 2) ? 'DN' : 'DH'
    }

    let objName = ''
    let objIp = {}
    let objType = 1

    if (_.size(ipList) === 2) { // with netmask
      // addressType = 'network'
      objType = 2
      objName += `${ipList[0]}_${ipList[1]}_${nameType}`
      // objIp = {
      //   ip_info1: ipList[0],
      //   ip_info2: ipList[1]
      // }
      objIp = ip
    } else {
      // addressType = 'host'
      objName = `${ipList[0]}_${nameType}`
      // objIp = [ipList[0]]
      objIp = ipList[0]
    }
    let verItem = 1
    if (version === 4) {
      verItem = 1
    } else if (version === 6) {
      verItem = 2
    }

    const hostDataInFirewall = {
      addr_obj_uname: objName,
      addr_obj_zone_type: zone,
      addr_obj_desc: menu,
      addr_obj_ip_exp: objIp,
      force_yn: 0,
      addr_obj_ip_ver_type: verItem,
      addr_obj_type: objType
    }

    const {code, result} = await this.$axios.$post(state.url, hostDataInFirewall, {successAlert: false})
    if (code === 'ok') {
      hostDataInFirewall.addr_obj_id = parseInt(result.msg)
      commit('cm/objectSecProfile/object/objectSettings/addressObject/saveAddressObjData', hostDataInFirewall, {root: true})
      commit('saveAddressObjData', hostDataInFirewall)
      return 'ok'
    } else if (code === '32010132') {
      return {'code': '32010132', 'result': result.msg}
    }
  }
}

export const strict = false
